import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=anon, obj=auth
  const [vendor, setVendor] = useState(null);

  const load = useCallback(async () => {
    const token = localStorage.getItem("ss_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setVendor(data.vendor || null);
    } catch {
      setToken(null);
      setUser(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const applyAuth = (data) => {
    setToken(data.token);
    setUser(data.user);
    setVendor(data.vendor || null);
  };

  const logout = () => {
    setToken(null);
    setUser(false);
    setVendor(null);
  };

  return (
    <AuthCtx.Provider value={{ user, vendor, setVendor, applyAuth, logout, reload: load }}>
      {children}
    </AuthCtx.Provider>
  );
}
